<template>
	<div class="main-content-container container-fluid px-4">
		<div>
			<div class="page-header row no-gutters py-4">
				<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
				  <span class="text-uppercase page-subtitle">{{ this.$route.params.slug }}</span>
				  <h3 class="page-title">Editar</h3>
			  </div>
		  </div>
		  <div class="row">
        <div class="col-lg-12">
          <div class="card card-small mb-3">
            <div class="card-body">
                <div class="form-group">
                	<input type="text" class="form-control" placeholder="Nombre" v-model="form.name">
                  <div class="invalid-feedback">
                    <!-- INSERT ERROR MESSAGE HERE -->
                  </div>
                </div>
                <div class="form-group">
                	<input type="text" class="form-control" placeholder="Slug" v-model="slug" readonly>
									<!-- INSERT ERROR MESSAGE HERE -->
                </div>
                <div class="form-group">
                	<textarea rows="4" class="form-control" placeholder="Descripción" v-model="form.description"></textarea>
                </div>
            </div>
            <div class="card-header border-top">
            	<button type="submit" class="btn btn-primary" @click.prevent="updateCategory">
            		Agregar
            	</button>
            </div>
          </div>
        </div>
		  </div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					id: '',
					name: '',
					description: ''
				},
				error: {
					name: {
						status: '',
						message: ''
					},
					description: {
						status: '',
						description: ''
					}
				}
			}
		},

		computed: {
			slug: function() {
				return this.form.name.toLowerCase().split(' ').join('_')
			}
		},

		mounted() {
			this.getCategory();
		},

		methods: {
			async getCategory() {
				const url = `${process.env.VUE_APP_ROOT_API}/category/${this.$route.params.slug}`;
				const response = await fetch(url);
				const data = await response.json();
				this.form.id = data.id;
				this.form.name = data.name;
				this.slug = data.slug;
				this.form.description = data.description;
			},

			async updateCategory() {
				const url = `${process.env.VUE_APP_ROOT_API}/category/${this.form.id}`;
				const data = {
					user_id: this.$store.state.auth.user.id,
					name: this.form.name,
					slug: this.slug,
					description: this.form.description
				};
				const settings = {
					method: 'PUT',
					body: JSON.stringify(data),
					headers: {
						'Content-type': 'application/json'
					}
				};
				const response = await fetch(url, settings);
				switch (response.status) {
					case 200:
						this.successMessage();
						break;
				}
			},

			successMessage() {
        this.$toasted.show("<i class='fas fa-hashtag'></i> Categoría actualizada!", { 
           theme: "toasted-primary", 
           position: "top-right", 
           duration : 2000
        });
        this.$router.replace('/categorias');
        this.cleanInputs();
			}

		}
	}
</script>